import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/es';
import Vue from "vue"

import ChatNotifications from "./components/Messages/ChatNotifications.vue";
import SupportNotifications from "./components/Messages/SupportNotifications.vue";

Vue.use(Element, {size: 'large', locale});

const app = new Vue({
    el: '#bellchat',
    components: {
        ChatNotifications,
        SupportNotifications,
    },
    data: {
        chats: [],
        chats_admin: [],
        user_id: null,
    },
    mounted() {
        this.user_id = document.head.querySelector('meta[name="user_id"]').content;
        this.$nextTick(()=>{
            this.fetchChats();
            this.fetchChatSupport();
            Echo.private(`chat.${this.user_id}`)
                .listen('MessageSentEvent', (element) => {
                    this.notificationChat(element);
                    if(window.location.pathname.split('/')[1] === 'online-chat'){
                        setTimeout(()=>{
                            this.fetchChats();
                            this.fetchChatSupport();
                        }, 100)
                    } else{
                        this.fetchChats();
                        this.fetchChatSupport();
                    }
                })

            if(window.location.pathname.split('/')[1] === 'online-chat'){
                setTimeout(()=>{
                    this.fetchChats();
                    this.fetchChatSupport();
                }, 200)
            }

            Echo.private(`notice.${this.user_id}`)
                .listen('NoticeEvent', (element) => {
                    this.notificationNotice(element);
                }
            )

        });
    },
    methods: {
        fetchChats() {
            axios.get('/api/online-chats?not_read=true').then(response => {
                this.chats = response.data
                this.fetchGroupChats()
            })
        },
        fetchChatSupport() {
            axios.get('/api/support-online-chat?not_read=true').then(response => {
                this.chats_admin = response.data;
            });
        },
        notificationNotice(e) {
            const h = this.$createElement;
            this.$notify({
                title: `Nuevo aviso`,
                message: h('i', { style: 'color: teal' }, e.notice_title),
                duration: 3000,
                onClick: () => {
                    window.location.href = `/noticias/${e.notice_id}`;
                },
            });
        },
        notificationChat(e){
            const h = this.$createElement;
            const message = e.message.message;
            const user = e.user;
            this.$notify({
                title: `Mensaje de ${user.chat_name_message}`,
                message: h('i', { style: 'color: teal' }, message),
                duration: 3000,
                /*
                onClick: () => {
                    window.location.href = `/online-chat/${user.id}`;
                },
                */
            });
        },
        fetchGroupChats(){
            axios
                .get('/api/online-group-chats?not_read=true')
                .then(response => {
                    let mychats = [...response.data, ...this.chats]
                    this.chats = mychats;
                })
        },
    }

});
const appmobile = new Vue({
    el: '#bellchat-mobile',
    components: {
        ChatNotifications,
        SupportNotifications,
    },
    data: {
        chats: [],
        chats_admin: [],
        user_id: null,
    },
    mounted() {
        this.user_id = document.head.querySelector('meta[name="user_id"]').content;
        this.$nextTick(()=>{
            this.fetchChats();
            this.fetchChatSupport();
            Echo.private(`chat.${this.user_id}`)
                .listen('MessageSentEvent', (element) => {
                    this.notificationChat(element);
                    if(window.location.pathname.split('/')[1] === 'online-chat'){
                        setTimeout(()=>{
                            this.fetchChats();
                            this.fetchChatSupport();
                        }, 100)
                    } else{
                        this.fetchChats();
                        this.fetchChatSupport();
                    }
                })

            if(window.location.pathname.split('/')[1] === 'online-chat'){
                setTimeout(()=>{
                    this.fetchChats();
                    this.fetchChatSupport();
                }, 200)
            }

            Echo.private(`notice.${this.user_id}`)
                .listen('NoticeEvent', (element) => {
                    this.notificationNotice(element);
                }
            )
        });
    },
    methods: {
        fetchChats() {
            axios.get('/api/online-chats?not_read=true').then(response => {
                this.chats = response.data
            })
        },
        fetchChatSupport() {
            axios.get('/api/support-online-chat?not_read=true').then(response => {
                this.chats_admin = response.data;
            });
        },
        notificationNotice(e) {
            const h = this.$createElement;
            this.$notify({
                title: `Nuevo aviso`,
                message: h('i', { style: 'color: teal' }, e.notice_title),
                duration: 3000,
                onClick: () => {
                    window.location.href = `/noticias/${e.notice_id}`;
                },
            });
        },
        notificationChat(e){
            const h = this.$createElement;
            const message = e.message.message;
            const user = e.user;
            this.$notify({
                title: `Mensaje de ${user.chat_name_message}`,
                message: h('i', { style: 'color: teal' }, message),
                duration: 3000,
                /*
                onClick: () => {
                    window.location.href = `/online-chat/${user.id}`;
                },
                */
            });
        },
    }

});
